import type { JSX } from 'react';
import { useParams } from 'react-router-dom';

import { ProductGrid } from './ProductGrid';
import { ProductView } from './ProductView';

/**
 * Product selection lives in the URL (not uiStore) — see ProductView.tsx. At
 * the /products index (no :productId), the whole layout is ProductGrid — the
 * landing/browse experience. Once a product is selected, the layout switches
 * to ProductView's full-page Kanban board (no sidebar — ProductView owns its
 * own header, filters, and board).
 */
export function ProductsLayout(): JSX.Element {
  const { productId } = useParams<{ productId: string }>();

  if (!productId) {
    return (
      <main className="h-full min-h-0 overflow-y-auto bg-background p-4">
        <ProductGrid />
      </main>
    );
  }

  return (
    <main className="h-full min-h-0 overflow-y-auto bg-background">
      <ProductView />
    </main>
  );
}
